import React, { useState, useEffect } from "react";
import { EXPAND } from "../../../core/theme/reportTheme";

// Lets a panel pop out to fill the screen. children(button, expanded) draws
// the panel; the panel puts the button in its top right corner.
// name: the panel's name for screen readers ("Expand Where you rank").
// The panel stays mounted when it expands (only the wrapper's classes change),
// so its own settings - sort, toggles - carry over. Esc or the backdrop closes it.
export default function Expandable({ className, name, children }) {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (!expanded) return undefined;
    const onKey = e => { if (e.key === "Escape") setExpanded(false); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [expanded]);

  const label = name
    ? (expanded ? `Close ${name}` : `Expand ${name}`)
    : (expanded ? "Close full screen" : "Expand to full screen");
  const button = (
    <button
      type="button"
      onClick={() => setExpanded(e => !e)}
      className={EXPAND.button}
      title={expanded ? "Close (Esc)" : "Expand to full screen"}
      aria-label={label}
    >
      {expanded ? "✕" : "⤢"}
    </button>
  );

  return (
    <>
      <div className={expanded ? EXPAND.open : className}>{children(button, expanded)}</div>
      {expanded && <div className={EXPAND.backdrop} onClick={() => setExpanded(false)} />}
    </>
  );
}
